
<template>
    <div id="google-map-wrapper">
        <div id="google-map"></div>
        <div id="button-map" style="display:none;">
            <div id="back-button-box">
                <div id='back-button'>Volver</div>
            </div>
        </div>
    </div>
</template>


<script>
    // Disable warning : Crisp found shims of native JavaScript methods.
    // This can alter the chatbox behavior and break things.
    // Make sure not to override listed functions to ensure your chatbox works as expected.
    // You may be looking for other JavaScript libraries in use on this page.
	// $crisp.push(["safe", true])

	let markers = [];
	let infoWindows = [];

    let provinces = [];

    const defaultMarker = GoogleMapsConfig.defaultMarker();

    let center = GoogleMapsConfig.defaultMarker();

	const markerUrlIconBlack = GoogleMapsConfig.markerBlack();
	const markerUrlIconWhite = GoogleMapsConfig.markerWhite();
    const markerUrlDefault = GoogleMapsConfig.markerDefault();

    const customStyles = GoogleMapsConfig.styles();
    const customStylesInside = GoogleMapsConfig.stylesInside();

    let zoom = 6.5;
    let zoomIn = 15;

    function deleteMarkers() {
        setMapOnAll(markers,null);
        markers = [];
        infoWindows = [];
    }

    function setMapOnAll(list, map) {
        for (var i = 0; i < list.length; i++) {
            list[i].setMap(map);
        }
    }

    function showButton (visible) {
        const controlUI = document.getElementById('back-button-box');
        controlUI.style.visibility = visible;
    }

    function setMarkers(map) {
        const markerIcon = {url: markerUrlDefault, scaledSize: new google.maps.Size(60, 72), labelOrigin: new google.maps.Point(25, 15)};

        for (let i = 0; i < provinces.length; i++) {
            let province = provinces[i];
            if (province.hasOwnProperty('notaries') && province.notaries.length) {
                markers[i] = new google.maps.Marker({
                    position: {lat: province.lat, lng: province.lng},
                    map: map,
                    icon: markerIcon,
                    // shape: shape,
                    title: province.name,
                    labelOrigin: new google.maps.Point(800,800),
                    label: {
                        text: province.name,
                        top: '2px',
                        color: "#014d41",
                        fontSize: "14px",
                        fontWeight: "bold",
                        fontFamily: "'Raleway'",
                        marginTop: "50px"
                    },
                    zIndex: 999
                });
                google.maps.event.addListener(markers[i], 'click', () => {
                    deleteMarkers();
                    markers = newMarkers(province, map);
                    map.setOptions({center: markers[i].getPosition(),draggable: true, scrollwheel: true, zoom: 15,disableDefaultUI: false, styles: customStylesInside});
                    showButton('visible');
                });
            }
        }
    }

    function newMarkers(data, map) {
    	let markersTemp = [];

        const markerIconBlack = {url: markerUrlIconBlack, scaledSize: new google.maps.Size(40, 52)};
        const markerIconWhite = {url: markerUrlIconWhite, scaledSize: new google.maps.Size(40, 52)};

    	if (data.hasOwnProperty('notaries')) {
    		for (let [index, value] of data.notaries.entries()) {
    			if (value.hasOwnProperty('address_gmaps')) {
                    const marker = new google.maps.Marker({
                        position: {lat: value.address_gmaps.latitude, lng: value.address_gmaps.longitude},
                        map: map,
                        icon: markerIconBlack,
                        title: value.name,
                        zIndex: 999
                    });

                    let website = value.website.indexOf('https') !== -1 || value.website.indexOf('http') !== -1 ? value.website : 'https://' + value.website;

                    const googleTooltip = Vue.extend({
                        parent: this,
                        template: `
                            <div class="box-info-notary">
                                <div class="header"><img alt="" src="${value.avatar_url}" class="img-map-notary"/> <div class="title">${value.name}</div></div>
                                <div class="summary">
                                    <div class="address"><div class="icon"><span class="icon-location-map"></span></div><div class="text"><span class="title-summary font-weight-bold">Dirección: </span> <span class="text-summary"><a href="https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${value.address_gmaps.place_id}" target="_blank">${value.address_gmaps.adr_address} ${value.address ? " | " + value.address : ""}</a></span></div></div>
                                    <div class="phone"><div class="icon"><span class="icon-phone-map"></span></div><div class="text"><span class="title-summary font-weight-bold">Teléfono: </span><span class="text-summary"><a href="telf:${value.phone}">${value.phone}</a></span></div></div>
                                    <div class="website"><div class="icon"><span class="icon-globe-1"></span></div><div class="text"><span class="title-summary font-weight-bold">Web: </span> <span class="text-summary"><a href="${website}" target="_blank">${value.website}</a></span></div></div>
                                    <div class="hours"><div class="icon"><span class="icon-clock-1"></span></div><div class="text"><span class="title-summary font-weight-bold">Horario: </span> <span class="text-summary">${value.hours}</span></div></div>
                                    <div class="actions"><span class="button" @click="handleContact">Contactar</span></div>
                                </div>
                            </div>
                        `,
                        methods: {
                            handleContact() {
                                bus.$emit('attachJsonToContactNotariesDialog', value)
                                bus.$emit('openContactNotariesModalBox', true)
                            }
                        }
                    })

                    infoWindows[value.id] = new google.maps.InfoWindow({
                        content: new googleTooltip().$mount().$el
                    });

                    marker.addListener('click', () => {
                        infoWindows[value.id].open(marker.get('map'), marker);
                        marker.setIcon(markerIconWhite)
                        google.maps.event.addListener(infoWindows[value.id],'closeclick',() => {
                            marker.setIcon(markerIconBlack)
                        });
                    });
                    markersTemp.push(marker);

                    if (data.notaries.length === 1) google.maps.event.trigger(marker, 'click');
                }
            }
        }
    	return markersTemp;
    }

    function CenterControl(controlDiv, map) {
			let controlUI = document.getElementById('back-button-box');
			controlDiv.appendChild(controlUI);

			let controlText = document.getElementById('back-button');
			controlUI.appendChild(controlText);

			controlUI.addEventListener('click', () => {
                showButton('hidden');
                deleteMarkers();
                setMarkers(map);
                map.setOptions({
                    zoom: zoom,
                    center: defaultMarker,
                    styles: customStyles,
                    scrollwheel: false,
                    draggable: false,
                    draggableCursor: 'pointer',
                    clickableIcons: false,
                    streetViewControl: false,
                    disableDefaultUI: true,
                    mapTypeControl: false,
                });
			});
    }

    import Province from '@/factories/province'
    import GoogleMapsConfig from '@/factories/googlemaps'
    export default {
        props: {
            apiKey: {type: String, required: false},
            region: String,
            language: String,
        },
        data() {
            return {
                map: {}
            }
        },
        async created() {
                await this.$http.get('/api/notaries-collaborators').then(
                response => {
                	provinces = Province.list(true, response.data)
                    this.createMap()
                }
            )
        },
        methods: {
        	createMap () {
                GoogleMapsLoader.KEY = this.apiKey;
                GoogleMapsLoader.LIBRARIES = ['places','drawing'];
                GoogleMapsLoader.LANGUAGE = this.language;
                GoogleMapsLoader.REGION = this.region;
                GoogleMapsLoader.load( (google) => {
                    this.initializeMap(google);
                });
            },
            initializeMap: (google) => {
                // resize when screen
                if (window.innerWidth <= 920) {
                    if (window.innerWidth > 425 && window.innerWidth <= 660) {
                    	zoom = 5.6
                        center = {lat:39, lng: -5}
                    } else if (window.innerWidth > 380 && window.innerWidth <= 425) {
                    	zoom = 5.4
                    } else {
                    	zoom = 5.2
                    }
                }

                // maps
                this.map = new google.maps.Map(document.getElementById('google-map'),
                  {
                    zoom: zoom,
                    center: center,
                    styles: customStyles,
                    scrollwheel: false,
                    draggable: false,
                    draggableCursor: 'pointer',
                    clickableIcons: false,
                    streetViewControl: false,
                    disableDefaultUI: true,
                    mapTypeControl: false,
                    minZoom: 0
                });

					// markers
					setMarkers(this.map)

					// button
					const centerControlDiv = document.getElementById('button-map')
					new CenterControl(centerControlDiv, this.map)
					centerControlDiv.index = 1
					this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(centerControlDiv)
					centerControlDiv.style.display = 'block'
				},
				initializeBus: (google) => {
					bus.$emit('map-initialized', google);
				}
			}
		}
</script>

<style lang="scss">
    @import "./../../sass/variables";

    /* map */
    #google-map-wrapper {
        box-shadow: 0 0 3px rgba(0,0,0,.10), 0 4px 8px rgba(0,0,0,.28);
    }

    #google-map{
        width: 100%;
        height: 60rem;

        @media only screen and (max-device-width: 36em) {
            height: 29rem;
        }

    }

    /* button */

    #back-button-box {
        background-color: #fff;
        border: 2px solid #fff;
        border-radius: 3px;
        box-shadow: 0 2px 6px rgba(0,0,0,.3);
        cursor: pointer;
        margin-bottom: 22px;
        margin-left: 20px;
        margin-top: 20px;
        width: 100px;
        text-align: center;
        visibility: hidden;
        opacity: 0.8;
    }

    #back-button-box:hover {
        box-shadow: 0 2px 6px rgba(0,0,0,.6);
        opacity: 1;
    }

    #back-button-box:focus, #back-button-box:active {
        box-shadow: 0 2px 6px rgba(0,0,0,.8);
        opacity: 0.6;
    }

    #back-button {
        color: #014d41;
        font-weight: bold;
        /* font-family: Roboto, Arial, sans-serif;*/
        font-size: 16px;
        line-height: 38px;
        padding-left: 5px;
        padding-right: 5px;
    }

    /* windowInfo */
    .gm-style .gm-style-iw-c {
        box-shadow: 0 3px 60px 0 rgba(0, 0, 0, 0.3);
        background-color: #ffffff;
        border-radius: 10px;
        padding: 0 !important;
    }

    .gm-style-iw-d {
        margin-bottom: 15px !important;
    }

    .box-info-notary {
        /*font-family: Raleway, sans-serif;*/
        max-width: 320px;
        margin: 0 10px 25px 25px;
        word-break: break-word;
        .header {
            margin-top: 20px;
            height: 50px;
            display: flex;
            .title {
                display: flex;
                justify-content: start;
                align-items: center;
                font-size: 16px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.38;
                letter-spacing: -0.1px;
                color: #014d41;
            }
            .img-map-notary {
                border-radius: 25px;
                margin-right: 11px;
                display: block;
                height: 50px;
                width: 50px;
                float: left;
                border: 1px solid #dad7d7;
            }
        }

        .summary {
            font-size: 14px;
            margin-top: 30px;
            .title-summary {}
            .text-summary {
                margin-left: 5px;
            }
            .icon {
                margin-right: 15px;
                height: 10px;
                width: 10px;
                float: left;
            }
            .text {
                margin-left: 20px;
            }
            div {
                margin-bottom: 15px;
            }
            .actions {
                .button {
                    float: right;
                    width: 84px;
                    height: 34px;
                    border: solid 1px #01382f;
                    background-color: #014d41;
                    color: white;
                    font-weight: bold;
                    text-align: center;
                    padding-top: 8px;
                    cursor: pointer;
                    border-radius: 4px;
                }
                .button:hover {
                    opacity: 0.8;
                }
                .button:focus, .button:active {
                    opacity: 0.6;
                }
            }
        }

    }

    .gm-style-iw > button {
        right: 0 !important;
        width: 40px !important;
        top: 12px !important;
        >img {
            width: 25px !important;
            height: 50px !important;
            margin: 0 !important;
            margin-right: 10px !important;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/GoogleMapNotariesCollaborators.vue